import React from "react";
import { usePayrollUploadLoader } from "./PayrollUploadLoaderContext";
import { Button, LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PayrollUploadLoader: React.FC = () => {
  const { loading } = usePayrollUploadLoader();
  const { showPayloadUploadLoader,warningText, hidePayloadUploadLoader } =
    usePayrollUploadLoader();

  const navigate = useNavigate();

  const handleButtonClick = () => {
    hidePayloadUploadLoader();
    navigate("/dashboard"); // Route to the /about page
  };
  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-content">
        {/* <div className="loader-bar-bg">
          <div className="loader-bar-progress"></div>
        </div> */}
        <img
          src="./success_check.png"
          alt="Success"
          style={{
            width: "93px",
            height: "93px",
            marginBottom: "30px"
          }}
        />
        <h2>Payroll files have been uploaded</h2>
        <div className="loader-desc">
          Payroll validation is in progress. You will get a notification when
          validation report is ready
        </div>
        {warningText && (
          <div
            style={{
              marginTop: "16px",
              color: "#FFCC00",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {warningText}
          </div>
        )}
        <Button
          className="footer-btn"
          onClick={handleButtonClick}
          variant="contained"
          sx={{
            textTransform: "none",
            mt: 10,
            fontFamily: "Inter",
            width: "268px",
            height: "44px",
            padding: "12px 16px",
            color: "#fff",
            backgroundColor: "#007CB0",
          }}
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default PayrollUploadLoader;
